import { ProjectsPage as Projects } from '../pages';
import { WithRouteData } from '../render-routes';

export const ProjectsPage = () => {
  return <Projects />;
};

export default WithRouteData(ProjectsPage);
